/**
 * `/local-walks` is preserved as a permanent redirect into the ONE PawLink
 * community/rescue map with the Walking Now filter pre-selected. There is
 * no second map — Local Walks is a layer/filter on the existing map.
 */
import { Navigate } from "react-router-dom";

export default function LocalWalks() {
    return <Navigate to="/community?filter=walking_now" replace />;
}
